<template>
<div class="popup_overlay">
  <div class="custom_dialog_comp bg-white h-full" style="width:100%">
    <div class="cust_card_comp">
      <div class="rounded px-5 py-4 h-full bg-primary text-white heading-2 font-bold flex items-center justify-between">
        <div>
          <p class="">engagement_models</p>
        </div>
        <div>
          <button class="list_top_card_btn font-bold bg-gray-200 cta-text text-text1 py-2 px-4 mr-2 rounded-3xl" @click="closeDetails(false)">Discard</button>
          <button class="list_top_card_btn font-bold  bg-success cta-text text-white py-2 px-4 rounded-3xl" @click="saveData()">Save</button>
        </div>  
      </div>
  <div class="p-0 bg-white" >
    <div class="bg-white p-2">
      <div class="pt-2 px-1 grid grid-cols-2 gap-x-2">
        <div class="box bg-white h-full cust_card">
          <div>
            <div class="p-2 pb-0 grid grid-cols-12">
              <div class="box col-span-12 p-2 pb-0">
                <p class="label_css">heading</p>
                <textarea v-model="fieldJsonData.heading"
                :class="heading_err ? 'border border-error' : ''"
                class="outline-none  text-gray-900 text-sm rounded  block w-full pl-2 p-2.5 h-12 heading-4 border border-gray-500 focus:border-gray-800" 
                placeholder="heading"
                ></textarea>
                <p v-if="heading_err" class="text-error heading-6">heading is required</p>
              </div>
              <div class="box col-span-12 p-2 pb-0">
                <p class="label_css">description</p>
                <editor v-model="fieldJsonData.description"
                :class="desc_err ? 'border border-error' : ''"
                placeholder="description"
                ></editor>
                <p v-if="desc_err" class="text-error heading-6">description is required</p>
              </div>
            </div>
              <div  class="mt-4" style="border: 1px solid gray"></div> 
          </div>
          <div class="py-2 px-1 grid  gap-x-2">
            <p class="label_css pl-2 font-bold">table_data</p>
           <div v-for="(data, index) in fieldJsonData.table_data" :key="index" class="p-2 pb-0 grid grid-cols-12">
                <div class="box col-span-6 p-2 pb-0">
                    <p class="label_css">col1</p>
                    <input v-model="data.col1"
                    :class="data.col1_err ? 'border border-error' : ''"
                    class="outline-none  text-gray-900 text-sm rounded  block w-full pl-2 p-2.5 h-12 heading-4 border border-gray-500 focus:border-gray-800" 
                    placeholder="col1"
                    >
                    <p v-if="data.col1_err" class="text-error heading-6">col1 is required</p>
                </div>
                <div class="box col-span-6 p-2 pb-0">
                    <p class="label_css">col2</p>
                    <input v-model="data.col2"
                    class="outline-none  text-gray-900 text-sm rounded  block w-full pl-2 p-2.5 h-12 heading-4 border border-gray-500 focus:border-gray-800" 
                    placeholder="col2"
                    >
                </div>
                <div class="box col-span-6 p-2 pb-0">
                    <p class="label_css">col3</p>
                    <input v-model="data.col3"
                    class="outline-none  text-gray-900 text-sm rounded  block w-full pl-2 p-2.5 h-12 heading-4 border border-gray-500 focus:border-gray-800" 
                    placeholder="col3"
                    >
                </div>
                <div class="box col-span-6 p-2 pb-0">
                    <p class="label_css">col4</p>
                    <input v-model="data.col4"
                    class="outline-none  text-gray-900 text-sm rounded  block w-full pl-2 p-2.5 h-12 heading-4 border border-gray-500 focus:border-gray-800" 
                    placeholder="col4"
                    >
                </div>
                <div class="box col-span-12 p-1 mt-3">
                <div class="flex justify-end">
                  <button v-if="index !== 0" class=" rounded-full h-8 w-8 bg-error  mr-1"
                    @click="removeTableData(index)"
                    >
                    <i class="fas fa-minus text-white heading-3"></i>
                  </button>
                  <button v-if="index === fieldJsonData.table_data.length - 1" class=" rounded-full h-8 w-8 bg-primary"
                  @click="addTableData()"
                    >
                    <i class="fas fa-plus text-white heading-3"></i>
                  </button>
                </div>
              </div>
                <div v-if="fieldJsonData.table_data.length - 1 !== index" class="mt-4 col-span-12" style="border: 1px solid gray; border-style: dashed"></div>
             </div>
             <div  class="mt-4" style="border: 1px solid gray"></div>
             <div class="py-2 px-1 grid  gap-x-2">
            <p class="label_css pl-2 font-bold">tab_heading</p>
           <div v-for="(data, index) in fieldJsonData.tab_heading" :key="index" class="p-2 pb-0 grid grid-cols-12">
                <div class="box col-span-6 p-2 pb-0">
                    <p class="label_css">heading</p>
                    <input v-model="data.heading"
                    :disabled="index === 0"
                    class="outline-none  text-gray-900 text-sm rounded  block w-full pl-2 p-2.5 h-12 heading-4 border border-gray-500 focus:border-gray-800" 
                    placeholder="heading"
                    >
                </div>
                <div class="box col-span-6 p-2 pb-0">
                    <p class="label_css">img_url</p>
                    <input v-model="data.img_url"
                    :disabled="index === 0"
                    class="outline-none  text-gray-900 text-sm rounded  block w-full pl-2 p-2.5 h-12 heading-4 border border-gray-500 focus:border-gray-800" 
                    placeholder="img_url"
                    >
                </div>
                <div class="box col-span-6 p-2 pb-0">
                    <p class="label_css">img_alt</p>
                    <input v-model="data.img_alt"
                    :disabled="index === 0"
                    class="outline-none  text-gray-900 text-sm rounded  block w-full pl-2 p-2.5 h-12 heading-4 border border-gray-500 focus:border-gray-800" 
                    placeholder="img_alt"
                    >
                </div>
                <div class="box col-span-12 p-1 mt-3">
                <div class="flex justify-end">
                  <button v-if="index !== 0" class=" rounded-full h-8 w-8 bg-error  mr-1"
                    @click="removeTabHeading(index)"
                    >
                    <i class="fas fa-minus text-white heading-3"></i>
                  </button>
                  <button v-if="index === fieldJsonData.tab_heading.length - 1" class=" rounded-full h-8 w-8 bg-primary"
                  @click="addTabHeading()"
                    >
                    <i class="fas fa-plus text-white heading-3"></i>
                  </button>
                </div>
              </div>
                <div v-if="fieldJsonData.tab_heading.length - 1 !== index" class="mt-4 col-span-12" style="border: 1px solid gray; border-style: dashed"></div>
             </div>
          </div>
          </div>
          <!-- <div class="p-2 pb-5 text-right">
            <div>
              <button class="list_top_card_btn bg-gray-200 cta-text text-text1 py-2 px-4 mr-2 rounded-3xl">Discard</button>
              <button class="list_top_card_btn bg-primary cta-text text-white py-2 px-4 mr-2 rounded-3xl" @click="saveData()">Save</button>
            </div>  
          </div> -->
        </div>
        <div>
        <img style="padding: 1px"  class="box border-1 shadow-lg rounded-lg" :src="componentImageUrl" :alt="componentImageUrl" />
      </div>
      </div>
    </div>
  </div>
    </div>
  </div>
</div>
</template>
<script>
import Editor from '../../../../../../components/editor.vue'
// import draggable from 'vuedraggable'
// import HRM from '@/View/CMS/api/HRM.js'
export default {
  components: {
    Editor
    // draggable,
  },
  props: ['componentDetailsForEdit', 'fieldJsonData', 'componentImageUrl', 'componentId'],
  data () {
    return {
      desc_err: false,
      heading_err: false,
      button_text_err: false,
      url_to_open_err: false,
      isError: true,
      // fieldJsonData: {
      //   component_name: "fieldJsonData",
      //   heading: "",
      //   description: "",
      //   table_data: [
      //       {
      //       col1: "",
      //       col2: "",
      //       col3: "",
      //       col4: ""
      //       },
      //       {
      //       col1: "",
      //       col2: "",
      //       col3: "",
      //       col4: ""
      //       },
      //       {
      //       col1: "",
      //       col2: "",
      //       col3: "",
      //       col4: ""
      //       },
      //       {
      //       col1: "",
      //       col2: "",
      //       col3: "",
      //       col4: ""
      //       },
      //       {
      //       col1: "",
      //       col2: "",
      //       col3: "",
      //       col4: ""
      //       }
      //   ],
      //   tab_heading: [
      //       {
      //           heading: "",
      //           img_alt: "",
      //           img_url: ""
      //       },
      //       {
      //           heading: "",
      //           img_alt: "",
      //           img_url: ""
      //       },
      //       {
      //           heading: "",
      //           img_alt: "",
      //           img_url: ""
      //       },
      //       {
      //           heading: "",
      //           img_alt: "",
      //           img_url: ""
      //       }
      //   ]
      // }
    }
  },
  created() {
    if (this.componentDetailsForEdit !== null) {
      console.log("componentDetailsForEdit!!!!!!!!!!!fieldJsonData", this.componentDetailsForEdit)
      this.fieldJsonData = this.componentDetailsForEdit
      console.log("this.fieldJsonData", this.fieldJsonData)
    }
  },
  mounted () {
  },
  watch: {
    fieldJsonData: {
      handler () {
        console.log('fieldJsonData 123', this.fieldJsonData)
        if (this.fieldJsonData.description !== '') {
          this.desc_err = false
          this.isError = false
        }
        if (this.fieldJsonData.heading !== '') {
          this.heading_err = false
          this.isError = false
        }
        for (let index = 0; index < this.fieldJsonData.table_data.length; index++) {
          if (this.fieldJsonData.table_data[index].col1 !== '') {
            this.fieldJsonData.table_data[index].col1_err = false
            this.isError = false
          }
        }
      },
      deep: true
    }
  },
  methods: {
    addTableData () {
      this.fieldJsonData.table_data.push({
        col1: "",
        col2: "",
        col3: "",
        col4: ""
      })
      console.log("addddddd", this.fieldJsonData.table_data);
    },
    removeTableData (index) {
      if (this.fieldJsonData.table_data.length !== 1) {
        this.fieldJsonData.table_data.splice(index, 1)
      }
      console.log("removeeeeeee", this.fieldJsonData.table_data);
    },
    addTabHeading () {
      this.fieldJsonData.tab_heading.push({
        heading: "",
        img_alt: "",
        img_url: ""
      })
      console.log("addddddd", this.fieldJsonData.tab_heading);
    },
    removeTabHeading (index) {
      if (this.fieldJsonData.tab_heading.length !== 1) {
        this.fieldJsonData.tab_heading.splice(index, 1)
      }
      console.log("removeeeeeee", this.fieldJsonData.tab_heading);
    },
    saveData() {
      console.log("componentDetailsForEdit", this.componentDetailsForEdit)
      if (this.fieldJsonData.description === '') {
        this.desc_err = true
        this.isError = true
      }
      if (this.fieldJsonData.heading === '') {
        this.heading_err = true
        this.isError = true
      }
      for (let index = 0; index < this.fieldJsonData.table_data.length; index++) {
          if (this.fieldJsonData.table_data[index].col1 === '') {
            this.fieldJsonData.table_data[index].col1_err = true
            this.isError = true
          }
      }
      if (this.isError === false) {
        for (let index = 0; index < this.fieldJsonData.table_data.length; index++) {
            delete this.fieldJsonData.table_data[index].col1_err
        }
        this.$emit('objData', this.fieldJsonData)
        this.componentDetailsForEdit = null
        let compIdImage = {
          imageUrl: this.componentImageUrl,
          id: this.componentId
        }
        // this.$emit('imageData', this.componentImageUrl)
        this.$emit('compIdImage', compIdImage)
        this.$root.$emit('closeComponentDialog', true)
        console.log("this.fieldJsonData............", this.fieldJsonData)
      }
    },
    closeDetails () {
    this.$root.$emit('closeComponentDialog', true)
    },
  },
  beforeDestroy () {
  }
}
</script>
<style scoped>
/* .list_top_card_btn {
  width: 163px !important;
  margin-right: 15px !important;
} */

::placeholder {
  font-size: 16px;
}
</style>